import React from 'react'
import connect from 'redux-connect-decorator'
import { ConfigProvider } from 'antd'
import { IntlProvider } from 'react-intl'
import AppRouter from 'routes'
import { ConnectedRouter } from 'connected-react-router'
import AppLanguage from 'languages'
import { isBOTIM } from 'utils'
import './styles/index.module.scss'
import './styles/iconfont.css'
import './styles/font-impact.css'
import './styles/keyframes.css'

@connect(
  (state) => ({
    siteConfig: state.siteConfig
  }),
  {}
)
class App extends React.Component {
  componentDidMount() {
    if (typeof document !== 'undefined') {
      if (isBOTIM()) {
        document.documentElement.setAttribute('data-brand', 'botim-money')
      } else {
        document.documentElement.removeAttribute('data-brand')
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    // 语言没切换的时候就不做update
    return this.props.siteConfig.language !== nextProps.siteConfig.language
  }

  render() {
    const { siteConfig, history } = this.props
    const lang = siteConfig.language
    return (
      <ConfigProvider locale={AppLanguage.antd[lang]} key={lang}>
        <IntlProvider
          locale={lang}
          key={lang}
          messages={AppLanguage['react-intl'][lang].messages}
        >
          <ConnectedRouter history={history}>
            <AppRouter history={history} />
          </ConnectedRouter>
        </IntlProvider>
      </ConfigProvider>
    )
  }
}

export default App
